export class ArrayUtilities {

    public static mapContainsKeyWithPartialString(mapCollection: Map<string,any>, searchString: string): string[] {
        return [...mapCollection.keys()].filter(key => key.includes(searchString));
    }

}